import {
  GET_LEADERBOARD_ERROR,
  GET_LEADERBOARD_LOADING,
  GET_LEADERBOARD_SUCCESS,
  GET_POTY_TOURNAMENT_SEASON_LOADING,
  GET_POTY_TOURNAMENT_SEASON_SUCCESS,
  GET_POTY_TOURNAMENT_SEASON_ERROR,
  CREATE_ADDSCRORECARD_ERROR,
  CREATE_ADDSCRORECARD_SUCCESS,
  CREATE_ADDSCRORECARD_LOADING,
  CLEAR_LEADERBOARD_DATA,
} from "../../../constant/actionTypes";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiGet, apiPut } from "../../../utils/apiRequests";

export const getLeaderboardProjectedScore = (id) => (dispatch) => {
  dispatch({ type: GET_LEADERBOARD_LOADING });
  apiGet(
    `${ApiEndpoints.leaderboard.base}${ApiEndpoints.leaderboard.getById}${id}`,
    (response) => {
      if (response.error === true) {
        dispatch({
          type: GET_LEADERBOARD_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: GET_LEADERBOARD_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: GET_LEADERBOARD_ERROR, response: error });
    }
  );
};

export const clearLeaderboardProjectedScore = () => (dispatch) => {
  dispatch({
    type: CLEAR_LEADERBOARD_DATA,
  });
};

export const getPotyTournamentSeasons = () => (dispatch) => {
  dispatch({ type: GET_POTY_TOURNAMENT_SEASON_LOADING });
  apiGet(
    `${ApiEndpoints.leaderboard.base}${ApiEndpoints.leaderboard.get}`,
    (response) => {
      if (response.error === true) {
        dispatch({
          type: GET_POTY_TOURNAMENT_SEASON_ERROR,
          response: response.message,
        });
      } else {
        dispatch({
          type: GET_POTY_TOURNAMENT_SEASON_SUCCESS,
          response: response,
        });
      }
    },
    (error) => {
      dispatch({ type: GET_POTY_TOURNAMENT_SEASON_ERROR, response: error });
    }
  );
};

export const addAdminAddPlayerScores = (data, id) => (dispatch) => {
  dispatch({ type: CREATE_ADDSCRORECARD_LOADING });

  apiPut(
    `${ApiEndpoints.leaderboard.base}${ApiEndpoints.leaderboard.addScorecard}${id}`,
    data,
    (response) => {
      if (response.error == true) {
        dispatch({
          type: CREATE_ADDSCRORECARD_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: CREATE_ADDSCRORECARD_SUCCESS, response: response });
        dispatch(getLeaderboardProjectedScore(id));
      }
    },
    (error) => {
      dispatch({ type: CREATE_ADDSCRORECARD_ERROR, response: error });
    }
  );
};
